import { en } from './en'
import { cn } from './cn'
// import { ind } from './ind'
export const lang = {
    en,
    cn
}